<template>
  <div class="form-row" v-loading.fullscreen.lock="isLoading" element-loading-background="rgba(256, 256, 256, 0.6)">
    <div class="col-md-6">
      <div class="form-group">
        <ValidationProvider ref="obs1" rules="required" v-slot="{ errors }">
          <fg-input :placeholder="$t('label.name_on_card')" v-model.lazy="cardholder_name" :error="errors[0]"></fg-input>
        </ValidationProvider>
      </div>

      <div class="form-group" v-if="isMounted">
        <card ref="newCard" class="form-control stripe-card" :stripe="stripeKey" :options="stripeOptions"
          :stripe-options="{ apiVersion: stripeKey.version }" @change="complete = $event.complete" />
      </div>
    </div>
    <div class="col-md-6 text-center">
      <img src="img/stripenomobilepay.svg" class="stripeImg" alt="Image" />
    </div>

    <div class="col-md-12 text-center ">
      <div class="save-card-btn ">
        <n-button :style="myTheme.customizeButton" :disabled="!complete || !cardholder_name" round type="primary"
          @click="saveCard()">{{ complete && cardholder_name ? $t("button.save_card") : $t("button.complete_details") }}
        </n-button>
      </div>
    </div>
    <!--el-divider></el-divider>
    <div class="col-md-12 text-center">
      <P>We also support the following methods at checkout</P>
    </div>
    <div class="col-md-12 text-center ">
      <div class="row justify-content-md-center">
      <div class="col-md-3 apple-pay-button-with-text apple-pay-button-black-with-text mr-4 ml-3 mb-2" >
        <span class="text">Apple Pay</span>
        <span class="logo"></span>
      </div> 
      <div class="col-md-3 button-google-pay pull-right ml-3 mr-4 mb-2"></div>

      </div>
    </div-->

    <el-divider></el-divider>
    <card-item v-for="(card, index) in userCards" :key="index" :card="card">
    </card-item>
  </div>
</template>
<script>
import { Button, FormGroupInput } from "@/components";
import { ValidationProvider } from "vee-validate";
import { mapActions } from "vuex";
import { CardItem } from "@/views/components";
import { Card, createToken } from "vue-stripe-elements-plus-sa";
import { stripeOptions } from "@/stripe/config.json";
import { getStripeKey, showErrorMessageAlert, getMessageFromAPIError, geMessageByStripeErrorCode } from "@/utilities/helper";

export default {
  name: 'add-card',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    CardItem,
    Card,
    ValidationProvider,
  },
  props: {
    userCards: Array,
  },
  data() {
    return {
      cardholder_name: null,
      stripeKey: getStripeKey(),
      stripeOptions: stripeOptions,
      complete: false,
      isLoading: false,
      isMounted: false,
    };
  },
  methods: {
    ...mapActions('userStore', ["addUserCardRequest"]),
    saveCard() {
      this.isLoading = true;
      createToken()
        .then((data) => {
          if (data.token) {
            this.addUserCardRequest({
              cardholder_name: this.cardholder_name,
              card: {
                id: data.token.id,
              },
            })
              .then((response) => {
                this.isLoading = false;
                if (response && response.error) {
                  showErrorMessageAlert(
                    getMessageFromAPIError(response)
                  );
                  return;
                }

                this.$notify({
                  group: "topRight",
                  title: this.$t("message.resource_added_notify_title", { resource_name: "Card" }),
                  type: "success",
                  text: this.$t("message.resource_added_notify_message", { resource_name: "Card" }),
                });
                this.clearInput();
              })
              .catch((e) => {
                this.captureException(e)
                this.cardFailed(getMessageFromAPIError(e.data));
              });
          } else {
            this.cardFailed(geMessageByStripeErrorCode(data));
          }
        })
        .catch((e) => {
          this.captureException(e)
          this.cardFailed(geMessageByStripeErrorCode(e));
        });
    },
    cardFailed(message) {
      //-- TODO : display a modal with message and ok button
      let full_message =
        "<p><i class='k-icon-sadface' style='color:" +
        this.staticColor.red +
        "' ></i></p><p>" +
        message +
        "</p>";
      let self = this;
      let options = {
        html: true,
        animation: "fade",
        type: "basic",
        backdropClose: false,
        customClass: "confirm",
      };
      this.$dialog.alert(full_message, options).then(function () {
        self.isLoading = false;
      });
    },
    clearInput() {
      this.cardholder_name = " ";
      let _cardElement = this.$refs.newCard.$refs.element._element;
      if (_cardElement) _cardElement.clear();
    },
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<style>
.stripeImg {
  width: 50%;
  margin: 5px;
  max-width: 170px;
}
</style>
